var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_684_841",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32.0001,
    width: 32,
    height: 32,
    transform: "rotate(180 32 32.0001)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_684_841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5898 11.3334C28.224 11.3334 28.7842 11.5766 29.2705 12.0629C29.7568 12.5492 30 13.1095 30 13.7437L30 15.8975C30 16.0374 29.9821 16.1874 29.9462 16.3473C29.9103 16.5073 29.8701 16.6565 29.8257 16.7949L26.0046 25.8118C25.8135 26.2381 25.4932 26.5983 25.0436 26.8923C24.5941 27.1864 24.125 27.3334 23.6364 27.3334L9.61547 27.3334L9.61547 11.3334L17.3719 3.64374C17.6368 3.37879 17.9437 3.22067 18.2924 3.16941C18.6411 3.11812 18.9753 3.17794 19.2949 3.34887C19.6145 3.51981 19.8487 3.76253 19.9974 4.07704C20.1462 4.39157 20.1778 4.7172 20.0923 5.05394L18.6564 11.3334L27.5898 11.3334ZM11.6154 12.1847L11.6154 25.3334L23.6411 25.3334C23.7351 25.3334 23.8312 25.3078 23.9295 25.2565C24.0278 25.2052 24.1026 25.1197 24.1539 25L28.0001 16.0001L28.0001 13.7437C28.0001 13.624 27.9616 13.5257 27.8847 13.4488C27.8077 13.3719 27.7094 13.3334 27.5898 13.3334L16.1283 13.3334L17.8001 6.02571L11.6154 12.1847ZM5.7437 27.3334C5.08088 27.3334 4.51347 27.0974 4.04147 26.6253C3.56945 26.1533 3.33343 25.5859 3.33343 24.9231L3.33343 13.7437C3.33343 13.0809 3.56944 12.5135 4.04147 12.0415C4.51347 11.5695 5.08088 11.3334 5.7437 11.3334L9.61547 11.3334L9.61547 13.3334L5.7437 13.3334C5.62403 13.3334 5.52573 13.3719 5.4488 13.4488C5.37187 13.5257 5.3334 13.624 5.3334 13.7437L5.3334 24.9231C5.3334 25.0428 5.37187 25.1411 5.4488 25.218C5.52573 25.2949 5.62404 25.3334 5.7437 25.3334L9.61547 25.3334L9.61547 27.3334L5.7437 27.3334Z",
    fill: "#05668D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbInactive);
export default __webpack_public_path__ + "static/media/thumb_inactive.a294b9bb12df8cf9b38f6fa7d1013ec6.svg";
export { ForwardRef as ReactComponent };